import { render, staticRenderFns } from "./ItemChipsWithMoreNew.vue?vue&type=template&id=cb0a3656"
import script from "./ItemChipsWithMoreNew.vue?vue&type=script&lang=ts"
export * from "./ItemChipsWithMoreNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb0a3656')) {
      api.createRecord('cb0a3656', component.options)
    } else {
      api.reload('cb0a3656', component.options)
    }
    module.hot.accept("./ItemChipsWithMoreNew.vue?vue&type=template&id=cb0a3656", function () {
      api.rerender('cb0a3656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ItemChipsWithMoreNew.vue"
export default component.exports